module.exports = __webpack_public_path__ + "static/media/tax_filling.c58753e6.png";